<template>
<div class="nav-breadcrumb-wrap">
    <!-- <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header> -->

    <div class="cont">
        <div v-if="!providerId" class="fican"  @click="handshow"><img src="../assets/dh.png" />  全部商品分类
        </div>
        <ul class="homenav">
            <li :class='{on:"/"===$route.path}' @click="homepage">
                首页
            </li>
            <!--<li :class='{on:"/inspection"===$route.path}' @click="inspection">检验所-->
            <!--</li>-->
            <!-- <li :class='{on:"/vendor"===$route.path}' @click="vendor">厂商
            </li> -->
            <!--<li @click="medicines" :class='{on:"/medicines"===$route.path}'>-->
                <!--药品-->
            <!--</li>-->
            <li v-if="!providerId" @click="toPCR" style="width: 240px;color: red;font-size: 15px;">
              人工智能新冠状病毒检测分析平台
            </li>
            <el-popover
              placement="bottom-start"
              trigger="hover">
              <div>
                <img src="../../static/medicines/code.png" style="width: 180px;height: 180px" alt="检验网扫码查真伪">
                <div style="text-align: center">扫码查真伪</div>
              </div>
              <li v-if="providerId" style="color:red" slot="reference">防伪查询</li>
            </el-popover>
        </ul>
        <transition name="fade">
            <div class="navigation" v-show="show">
                 <div v-for="item in fenlei" :key="item.id">
                      <h2>{{item.name}}</h2>
                      <ul class="flnav">
                          <li v-for="item2 in item.child" :key="item2.id">
                              <!--<span  @click="todetection(item2.id,item2.remark)" :class="{'on': tabIdx === item2.id}">{{item2.name}}
                                <div class="submanu1">
                                  <a href="javascript:void(0)"  @click.stop="todetection(item3.id,item3.remark)"  :class="{'on': tabIdx === item3.id}" v-for="item3 in item2.child" :key="item3.id">{{item3.name}}</a>
                                </div>

                              </span>-->

                            <div class="submanu">
                              <a href="javascript:void(0)"  @click="todetection(item3.id,item3.remark,item3.name)"  :class="{'on': tabIdx === item3.id}" v-for="item3 in item2.child" :key="item3.id">{{item3.name}}</a>
                              <a href="javascript:void(0)" @click="todetection(item.id,item.remark,item.name)">全部</a>
                            </div>
                          </li>
                      </ul>
                  </div>
            </div>
        </transition>
            <!-- <nav class="nav-breadcrumb">
                <router-link to="/">
                  首页
                </router-link>
                <router-link to='goodsList'>
                  <slot name="goods"></slot>
                </router-link>
                <slot name="detail"></slot>
                <slot name="cart"></slot>
                <slot name="address"></slot>
                <slot name="confirmOrder"></slot>
                <slot name="confirmSuccess"></slot>
                <slot name="company"></slot>
                <slot name="com_allgoods"></slot>
                <slot name="mine"></slot>
                <slot name="orderList"></slot>
                <slot name="orderDesc"></slot>
                <slot name="setting"></slot>
            </nav> -->
    </div>
</div>
</template>

<script>
import NavHeader from '@/components/Header'

import axios from 'axios'
import {getCookie, setCookie, delCookie, removeHTMLTag, isValidPhone,isValidLoginName,isValidPassword} from '../util/util.js'


export default {
  data() {
      return {
        show: false,
        tabIdx:0,
        fenlei:[],
        loginModalFlag: false,
        p_loginModalFlag: false,
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || ''
      }
  },
  watch: {
    '$store.state.providerId': function(val) {
      this.providerId = val
    }
  },
  mounted() {
    this.getfenlei();
  },
  components: {
    NavHeader,
  },
    methods: {
        toGoodsList1(){
        this.$router.push("/goodsList")
      },
        homepage() {
          this.providerId?this.$router.push({path: "/company/index", query: {id: this.providerId}}):this.$router.push('/')
        },
        complaypage(){
          this.$router.push({path: "/company/index", query: {id: this.providerId}})
        },
        inspection() {
            this.$router.replace("/inspection")
        },
        medicines() {
            this.$router.push("/medicines")
        },
        vendor() {
            this.$router.replace("/Vendor")
        },
        handshow() {
            this.show = !this.show;
        },
       //获取首页分类
       getfenlei() {
            axios.get("/jys/category/p?shopId=" + this.providerId).then((res) => {
               this.fenlei = res.data.list;
            })
        },
      todetection(id, remark,name) {
        this.tabIdx = id;
        console.log(name)
        this.$router.push({
          path: "/goodsList",
          query: {
            id: id,
            remark: remark,
            name: name
          }
        })
      },
      showLoginModal(){
        this.$emit("showLoginModal")
      },
      p_showLoginModal() {
        console.log('click toPCR showLoginModal')
        this.p_loginModalFlag = true
      },
      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },
      toPCR() {
        let _token = getCookie("_token")
        let userId = getCookie("userId")

        if (getCookie("_token")) {
          // 日志操作记录
          axios.post("/jys/log", {
            logInfo: '跳转到 PCR 页面',
          }, {
            headers: {
              "Content-Type": "application/json",
              'token': getCookie("_token"),
            }
          }).then((response) => {
            console.log('response', response)
          })
          window.open("http://47.103.75.157:8007" + "?token=" + _token + "&userId=" + userId, "blank")
        } else {
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });

          // console.log('向父组件通信')
          this.$emit("indexPCR")

          // this.p_showLoginModal()
        }
      }

        /* addClassload(index){
              this.classenable=true
              this.current=index;
            },
            removeClassload(index){
              this.classenable=false
              this.current=index;
            } */
  },
}
</script>

<style scoped>
.nav-breadcrumb a:after {
    position: absolute;
    top: 3px;
    right: -12px;
    content: "";
    line-height: 1.2;
}

.nav-breadcrumb span {
    position: relative;
}

.nav-breadcrumb span:before {
    position: absolute;
    top: 3px;
    left: -12px;
    content: ">";
    line-height: 1.2;
}

.cont {
    margin: 0 auto;
    height: 32px;
    background-color: #F5F5F5;
}

.container {
    width: 90%;
    margin: 0 auto;
    padding: 0 10px;
    margin-bottom: 20px;
}

.fican {
    background: #00C4AA;
    float: left;
    width: 220px;
    height: 32px;
    color: #fff;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    position: relative;
}

.fican img {
    vertical-align: middle;
}

.homenav {
    float: left;
    line-height: 32px;
    margin-left: 30px;
    cursor: pointer;
}

.homenav li {
    text-align: center;
    float: left;
    font-weight: bold;
    width: 80px;
}

.homenav li a {
    display: block;
}

.navigation {
    width: 220px;
    min-height: 370px;
    position: absolute;
    top: 112px;
    background: rgba(0, 0, 0, .7);
    z-index: 9999999;
    padding: 5px 10px;
    color: #fff;
}

.navigation h2 {
    font-size: 14px;
    border-bottom: 2px solid rgba(255, 255, 255, .5);
    line-height: 35px;
    padding-left: 10px;
}

.flnav {
    font-size: 12px;
    margin: 10px 0 5px 10px;
}

.flnav>li {
    cursor: pointer;
  width: 200px;
  margin-top: 8px;
}
.flnav>li>span{
  position: relative;
  display: block;
}
.flnav>li>span:hover{
  background:url(../assets/aw.png) no-repeat -3px 2px;
  padding-left: 10px;color: #03DAC4;
}
.flnav>li>span:hover .submanu1 {
    display: block;
    color: #fff;
}
.submanu1{
  display: none;
  position: absolute;background: rgba(0, 0, 0, .7);
  left: 200px;
  width: 300px;
  padding: 10px;
  top: -10px;
}
.flnav>li a:hover,
.on {
    color: #00C4AA;
}
.submanu{
  height: 30px;
  /*overflow: hidden;*/
}
.submanu a,.submanu1 a {
    display: block;
    float: left;
    margin: 10px 17px 10px 0;
    line-height: 12px;
    border-left: 1px solid #88858c;
    padding-left: 5px;width: 83px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.router-active-class {
    color: #00C4AA;
}

</style>



// WEBPACK FOOTER //
// src/components/Bread.vue